import React from 'react'
import Svg, { Rect, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconCopy = (props: Props) => {
  const { width, height, color = Color.premiumBlack, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconCopy.dimensions.width} ${IconCopy.dimensions.height}`}
      {...otherProps}
    >
      <Rect x={5.5} y={1.5} width={8} height={10} rx={1.2} stroke={color} strokeWidth={0.5} fill="none" />
      <Rect x={2.5} y={4.5} width={8} height={10} rx={1.2} stroke={color} strokeWidth={0.5} fill="none" />
    </Svg>
  )
}

IconCopy.dimensions = {
  width: 16,
  height: 16,
}

export default IconCopy
